(() => {
  if (window.__syncPromoHeightsRegistered) return;
  window.__syncPromoHeightsRegistered = true;

  function syncPromoHeights(root) {
    const scope = root || document;

    scope.querySelectorAll('.product-list').forEach((listEl) => {
      const cards = listEl.querySelectorAll('.product-card');
      if (!cards.length) return;

      const firstCard = cards[0];
      const cardHeight = firstCard.offsetHeight;
      if (!cardHeight) return;

      // Build a flat list of visible items (products + promos) with their top positions
      const items = [];
      Array.prototype.forEach.call(listEl.children, (child) => {
        if (!child.matches('.product-card, .product-list__promo')) return;

        const rect = child.getBoundingClientRect();
        if (!rect || !rect.height) return;

        items.push({
          el: child,
          type: child.classList.contains('product-list__promo') ? 'promo' : 'product',
          top: rect.top,
        });
      });

      if (!items.length) return;

      // Group items into visual rows by similar top coordinate
      items.sort((a, b) => a.top - b.top);
      const rows = [];
      let currentRow = [];
      let currentTop = null;
      const threshold = 4; // px tolerance between items in same row

      items.forEach((item) => {
        if (currentTop === null || Math.abs(item.top - currentTop) <= threshold) {
          currentRow.push(item);
          if (currentTop === null) currentTop = item.top;
        } else {
          rows.push(currentRow);
          currentRow = [item];
          currentTop = item.top;
        }
      });
      if (currentRow.length) rows.push(currentRow);

      // Determine which promos are in rows that contain only promos
      const promoOnlyPromos = new Set();
      rows.forEach((row) => {
        const hasProduct = row.some((item) => item.type === 'product');
        if (!hasProduct) {
          row.forEach((item) => {
            if (item.type === 'promo') promoOnlyPromos.add(item.el);
          });
        }
      });

      // Reset previous promo content min-heights.
      listEl.querySelectorAll('.product-list__promo .content-box').forEach((boxEl) => {
        boxEl.style.minHeight = '';
      });

      // Apply min-height only to promos in promo-only rows.
      promoOnlyPromos.forEach((promoEl) => {
        const size = promoEl.getAttribute('data-promo-size') || '1_1';
        const parts = size.split('_');
        const rowsSpan = parseInt(parts[1], 10) || 1;
        const targetHeight = cardHeight * rowsSpan;
        const boxEl = promoEl.querySelector('.content-box');

        if (boxEl) {
          boxEl.style.minHeight = `${targetHeight}px`;
        } else {
          promoEl.style.minHeight = `${targetHeight}px`;
        }
      });
    });
  }

  let resizeRaf;
  let cardsObserver = null;

  document.addEventListener('DOMContentLoaded', () => {
    syncPromoHeights();

    // Debounced resize handler to avoid layout thrashing
    window.addEventListener('resize', () => {
      if (resizeRaf) {
        cancelAnimationFrame(resizeRaf);
      }

      resizeRaf = requestAnimationFrame(() => {
        syncPromoHeights();
      });
    });

    // Observe product card size changes and resync when they change
    if ('ResizeObserver' in window && !cardsObserver) {
      cardsObserver = new ResizeObserver((entries) => {
        // If any observed product card changes size, resync heights once
        if (!entries.length) return;
        syncPromoHeights();
      });

      document.querySelectorAll('.product-list .product-card').forEach((card) => {
        cardsObserver.observe(card);
      });
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target.querySelector('.product-list')) return;
    syncPromoHeights(event.target);

    // Start observing newly added product cards as well
    if (cardsObserver) {
      event.target.querySelectorAll('.product-list .product-card').forEach((card) => {
        cardsObserver.observe(card);
      });
    }
  });

  // Recalculate heights when a section or block is selected in the theme editor
  document.addEventListener('shopify:section:select', (event) => {
    if (!event.target.querySelector('.product-list')) return;
    syncPromoHeights(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('.shopify-section');
    if (!section || !section.querySelector('.product-list')) return;
    syncPromoHeights(section);
  });
})();

